module.exports = __webpack_public_path__ + "media/images/front/icon_like_off-ec0faf31484a4dc319e316aa8e472f0d.png";